import React from "react";
import img from "../../../Assets/Slider2.jpg";
import style from "./Slide1.module.css";
import Button from "@mui/material/Button";

export const Slide2 = () => {
  return (
    <div className={style.slide}>
      <div className={style.item1}>
        <div className={style.textCont}>
          <h1 className={style.title}> El espacio ideal para hacer crecer tu negocio.</h1>
          <p className={style.txt}>
          Somos más que un co-working, nuestros espacios te brindan las herramientas necesarias para hacer crecer tu negocio.
            <div className={style.spacer}> </div>Bienvenido a The Lawyers CoWorking.
          </p>
          <Button variant="contained" color="primary" className={style.btn}>
            Haz una cita
          </Button>
        </div>
      </div>
      <div className={style.item2}>
        <img src={img} alt="" className={style.img} />{" "}
        <div className={style.colors}>
          <div className={style.color1}></div>
          <div className={style.color2}></div>
          <div className={style.color3}></div>
        </div>
      </div>
    </div>
  );
};
